/**
 * This is a little bit different version of module31form.js
 * This form page contains additional feature for "Save Question", "Edit selected", and "Delete selected"
 * which is not available on module31form.js that will used in Add New Chapters without those feature
 */


import React, { useCallback, useRef, useState } from 'react'
import Textarea from '../fields/textarea'
import Input from '../fields/input'
import { Button, Grid, List, Divider, Modal } from 'semantic-ui-react'
import { Form } from 'react-advanced-form';
import { toast } from 'react-toastify';
import messages from './validation_message';

const DEFAULT_QUESTION_OBJECT_DATA = {
    title: '',
    passage: '',
    answer: '',
    wrong1: '',
    wrong2: '',
    wrong3: ''
}


const Module31FormA = (props) => {
    const {
        on_save_question,
        formPassageModule31Ref,
        formRefUpdateSingle,
        data,
        is_edit
    } = props

    const [isAskingDelete, setIsAskingDelete] = useState()
    const [viewMode, setViewMode] = useState('form')
    const formRef = useRef(null)
    const formRefUpdate = useRef(null)


    const [initialReviewForm, setInitialReviewForm] = useState([])
    const [editedIndex, setEditedIndex] = useState()
    const [passageEditSingle, setPassageEditSingle] = useState(data?.question_object?.passage || '')
    const [titleEditSingle, setTitleEditSingle] = useState(data?.question_object?.data?.title || '')
    const [editSingleQuestionData, setEditSingleQuestionData] = useState(data?.question_object?.data ? {
        ...data.question_object.data
    }: DEFAULT_QUESTION_OBJECT_DATA)

    const save = ({ serialized, fields }) => {
        if (!Boolean(is_edit)) {
            let message = []
            let isValid = true
            const keys = Object.keys(fields)
            keys.forEach(k => {
                if (fields[k].invalid) {
                    message.push(<div>
                        Please check maximum character or correct input on <b style={{ textTransform: 'uppercase' }}>{fields[k].label || k}</b>
                    </div>)
                    isValid = false
                }
            });

            //checking questions
            if (initialReviewForm.length <= 0) {
                message.push(<div>Please fill the question first</div>)
                isValid = false
            }

            if (!isValid) {
                const view = <List bulleted>
                    {message.map((v, k) => <List.Item key={k}>{v}</List.Item>)}
                </List>
                toast.error(view)
                return new Promise((resolve) => resolve())
            }

            const payload = {
                passage: serialized.passage,
                data: {
                    title: serialized.title,
                    questions: initialReviewForm
                }
            }

            on_save_question && on_save_question(payload, false)
            return new Promise((resolve) => resolve())
        } else {

            let message = []
            let isValid = true
            const keys = Object.keys(fields)
            keys.forEach(k => {
                if (fields[k].invalid) {
                    message.push(<div>
                        Please check maximum character or correct input on <b style={{ textTransform: 'uppercase' }}>{fields[k].label || k}</b>
                    </div>)
                    isValid = false
                }
            });


            if (!isValid) {
                const view = <List bulleted>
                    {message.map((v, k) => <List.Item key={k}>{v}</List.Item>)}
                </List>
                toast.error(view)
                return new Promise((resolve) => resolve())
            }


            formRefUpdateSingle?.current?.submit()
            setPassageEditSingle(serialized.passage)
            setTitleEditSingle(serialized.title)
            return new Promise((resolve) => resolve())
        }




    }

    const handleSaveUpdate = ({ serialized, fields }) => {
        let message = []
        let isValid = true
        const keys = Object.keys(fields)
        keys.forEach(k => {
            if (fields[k].invalid) {
                message.push(<div>
                    Please check maximum character or correct input on <b style={{ textTransform: 'uppercase' }}>{fields[k].label || k}</b>
                </div>)
                isValid = false
            }
        });

        if (!isValid) {
            const view = <List bulleted>
                {message.map((v, k) => <List.Item key={k}>{v}</List.Item>)}
            </List>
            toast.error(view)
            return new Promise((resolve) => resolve())
        }


        const old = [...initialReviewForm]
        old.splice(editedIndex, 1, { ...serialized });
        setViewMode('view')
        setEditedIndex(undefined)
        setInitialReviewForm(old)
        return new Promise((resolve) => resolve())
    }

    const handleSaveUpdateSingle = ({ serialized, fields }) => {
        let message = []
        let isValid = true
        const keys = Object.keys(fields)
        keys.forEach(k => {
            if (fields[k].invalid) {
                message.push(<div>
                    Please check maximum character or correct input on <b style={{ textTransform: 'uppercase' }}>{fields[k].label || k}</b>
                </div>)
                isValid = false
            }
        });

        if (!isValid) {
            const view = <List bulleted>
                {message.map((v, k) => <List.Item key={k}>{v}</List.Item>)}
            </List>
            toast.error(view)
            return new Promise((resolve) => resolve())
        }


        const payload = {
            passage: passageEditSingle,
            passage_id: data.question_object.passage_id,
            data: {
                ...serialized,
                title: titleEditSingle,
            }
        }

        on_save_question && on_save_question(payload)
        return new Promise((resolve) => resolve(serialized))
    }


    const handleSave = ({ serialized, fields }) => {
        const keys = Object.keys(fields)
        let message = []
        let isValid = true
        keys.forEach(k => {
            if (fields[k].invalid) {
                message.push(<div>
                    Please check maximum character or correct input on <b style={{ textTransform: 'uppercase' }}>{fields[k].label || k}</b>
                </div>)
                isValid = false
            }
        });
        if (!isValid) {
            const view = <List bulleted>
                {message.map((v, k) => <List.Item key={k}>{v}</List.Item>)}
            </List>
            toast.error(view)
            return new Promise((resolve) => resolve())
        }


        setInitialReviewForm(prev => {
            return ([...prev, { ...serialized }])
        })
        setViewMode('view')
        return new Promise((resolve) => resolve())
    }


    const ModalDelete = () => (
        <Modal size='tiny' open={Boolean(isAskingDelete)}>
            <Modal.Content style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 20, paddingBottom: 10, backgroundColor: '#FFE8E6' }}>
                <div className='publishModal'>
                    <div className='content'>
                        <h3>Confirmatiom</h3>
                        <p>
                            Do you want to delete question?
                        </p>
                    </div>
                </div>
                <Divider hidden />




                <Grid padded>
                    <Grid.Row style={{ justifyContent: 'end' }}>
                        <Button
                            secondary
                            onClick={() => {
                                setIsAskingDelete(undefined)
                            }}
                        >Cancel</Button>
                        <Button
                            negative
                            onClick={() => {
                                const filtered = initialReviewForm.filter(draft => draft !== isAskingDelete)
                                setInitialReviewForm(filtered)
                                setIsAskingDelete(undefined)
                            }}
                        >Delete</Button>
                    </Grid.Row>
                </Grid>
            </Modal.Content>

        </Modal>
    )

    const ListPreview = () => (
        <>
            {
                initialReviewForm?.map((draft, index) => (
                    viewMode === 'form' && editedIndex === index ? <></> :
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <h5>Question #{(index + 1)}</h5>
                            <p style={{ marginBottom: 2 }}>{draft?.question || '-'}</p>

                            <h5>Correct Answer</h5>
                            <p style={{ marginBottom: 2 }}>{draft?.answer || '-'}</p>

                            <h5 style={{ color: 'red' }}>Wrong Answer</h5>
                            <li>{draft?.wrong1 || '-'}</li>
                            <li>{draft?.wrong2 || '-'}</li>
                            <li>{draft?.wrong2 || '-'}</li>

                            {
                                editedIndex === undefined && viewMode !== 'form' && <div style={{ alignSelf: 'flex-end', justifyItems: 'center' }}>
                                    <Button
                                        key={1}
                                        floated='left'
                                        secondary
                                        onClick={() => {
                                            setViewMode('form')
                                            setEditedIndex(index)
                                        }
                                        }>
                                        Edit
                                    </Button>
                                    <Button key={2} negative onClick={() => { setIsAskingDelete(draft) }}>Delete</Button>
                                </div>
                            }


                            <Divider />
                        </div>
                ))
            }
        </>

    )


    const NewForm = () => {
        return <Form messages={messages} ref={formRef} action={handleSave} className='ui form'>
            <Textarea
                required
                label={`Question`}
                name="question"
                placeholder='Type here'
                wlength={200} />
            <Input
                label='Correct answer'
                name="answer"
                required
                placeholder='Type your correct answer'
                wlength={150} />
            <label style={{ color: 'red' }}>Wrong Answer*</label>
            <Input
                name="wrong1"
                required
                placeholder='Type your wrong answer'
                wlength={150} />
            <Input
                name="wrong2"
                required
                placeholder='Type your wrong answer'
                wlength={150} />
            <Input
                name="wrong3"
                required
                placeholder='Type your wrong answer'
                wlength={150} />

            {
                !Boolean(is_edit) && (
                    <Grid padded>
                        <Grid.Row>
                            <Button
                                floated='left'
                                positive
                                onClick={() => {
                                }
                                }>
                                Save Question
                            </Button>
                            <Button
                                className='tertiary'
                                onClick={() => {
                                    setEditedIndex(undefined)
                                    setViewMode('view')
                                }}>Discard</Button>
                        </Grid.Row>
                    </Grid>
                )
            }

        </Form>
    }


    const EditForm = () => {
        return <Form messages={messages} ref={formRefUpdate} action={handleSaveUpdate} className='ui form'>
            <Textarea
                initialValue={editedIndex !== undefined ? initialReviewForm[editedIndex].question : ''}
                required
                label={`Question #` + (editedIndex + 1)}
                name="question"
                placeholder='Type here'
                wlength={200} />
            <Input
                initialValue={editedIndex !== undefined ? initialReviewForm[editedIndex].answer : ''}
                label='Correct answer'
                name="answer"
                required
                placeholder='Type your correct answer'
                wlength={150} />
            <label style={{ color: 'red' }}>Wrong Answer*</label>
            <Input
                initialValue={editedIndex !== undefined ? initialReviewForm[editedIndex].wrong1 : ''}
                name="wrong1"
                required
                placeholder='Type your wrong answer'
                wlength={150} />
            <Input
                initialValue={editedIndex !== undefined ? initialReviewForm[editedIndex].wrong2 : ''}
                name="wrong2"
                required
                placeholder='Type your wrong answer'
                wlength={150} />
            <Input
                initialValue={editedIndex !== undefined ? initialReviewForm[editedIndex].wrong3 : ''}
                name="wrong3"
                required
                placeholder='Type your wrong answer'
                wlength={150} />

            {
                !Boolean(is_edit) && (
                    <Grid padded>
                        <Grid.Row>
                            <Button
                                floated='left'
                                positive
                            >
                                Update Question
                            </Button>
                            <Button className='tertiary' onClick={() => {
                                setViewMode('view')
                                setEditedIndex(undefined)
                            }}>Discard</Button>
                        </Grid.Row>
                    </Grid>
                )
            }
        </Form>
    }

    const EditSingleForm = useCallback(() => {
        const {
            question,
            answer,
            wrong1,
            wrong2,
            wrong3
        } = data.question_object.data
        return <Form messages={messages} ref={formRefUpdateSingle} action={handleSaveUpdateSingle}>
            <Input type="hidden" name="title" value={titleEditSingle || ''} />            
            <Input type="hidden" name="passage" value={passageEditSingle || ''} />
            <Textarea                
                initialValue={editSingleQuestionData.question}
                onChange={v => setEditSingleQuestionData((prev) => {
                    return {
                        ...prev,
                        question: v.nextValue
                    }
                })}
                required
                label={`Question`}
                name="question"
                placeholder='Type here'
                wlength={200} />
            <Input
                initialValue={editSingleQuestionData.answer}
                onChange={v => setEditSingleQuestionData((prev) => {
                    return {
                        ...prev,
                        answer: v.nextValue
                    }
                })}
                label='Correct answer'
                name="answer"
                required
                placeholder='Type your correct answer'
                wlength={150} />
            <label style={{ color: 'red' }}>Wrong Answer*</label>
            <Input
                initialValue={editSingleQuestionData.wrong1}
                onChange={v => setEditSingleQuestionData((prev) => {
                    return {
                        ...prev,
                        wrong1: v.nextValue
                    }
                })}
                name="wrong1"
                required
                placeholder='Type your wrong answer'
                wlength={150} />
            <Input
                initialValue={editSingleQuestionData.wrong2}
                onChange={v => setEditSingleQuestionData((prev) => {
                    return {
                        ...prev,
                        wrong2: v.nextValue
                    }
                })}
                name="wrong2"
                required
                placeholder='Type your wrong answer'
                wlength={150} />
            <Input
                initialValue={editSingleQuestionData.wrong3}
                onChange={v => setEditSingleQuestionData((prev) => {
                    return {
                        ...prev,
                        wrong3: v.nextValue
                    }
                })}
                name="wrong3"
                required
                placeholder='Type your wrong answer'
                wlength={150} />
        </Form>
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [passageEditSingle, titleEditSingle])


    return <>
        <td>
            <Form messages={messages} ref={formPassageModule31Ref} action={save}>
                <Input
                    label='Title'
                    name="title"
                    initialValue={Boolean(is_edit) ? data.question_object.data?.title : ''}
                    placeholder='Type your title'
                    onChange={Boolean(is_edit) ? v => setTitleEditSingle(v.nextValue) : undefined}
                    wlength={50} />
                <Textarea
                    onChange={Boolean(is_edit) ? v => setPassageEditSingle(v.nextValue) : undefined}
                    initialValue={Boolean(is_edit) ? data.question_object.passage : ''}
                    rows='12'
                    label='Passage'
                    name="passage"
                    required
                    placeholder='Type your passage'
                    useWordAsCount={true}
                    wlength={1500} />
            </Form>

        </td>
        <td>

            <ListPreview />

            {viewMode === 'form' && !Boolean(is_edit) && editedIndex === undefined && <NewForm />}

            {viewMode === 'form' && !Boolean(is_edit) && editedIndex !== undefined && <EditForm />}

            {viewMode === 'form' && Boolean(is_edit) && editedIndex === undefined && <EditSingleForm />}

            {viewMode === 'view' && !Boolean(is_edit) && initialReviewForm.length < 5 && <Grid padded>
                <Grid.Row>
                    <Button
                        key={1}
                        floated='left'
                        positive
                        onClick={() => {
                            setViewMode('form')
                            setEditedIndex(undefined)
                        }
                        }>
                        Add More Question
                    </Button>
                </Grid.Row>
            </Grid>}






        </td>
        <ModalDelete />
    </>
}


export default Module31FormA

